<template>

    <div class="col-md-12 perfilPerito">
        <div class="ibox">
            <div class="ibox-content chat-view">
                <div class="chat-activity-list">
                    <div v-for="(item, index) in sortedItems" :key="index">

                        <div v-if="item.type === 'message'" class="chat-element" :class="{ 'right': item.sender_id === currentUser.id, 'chat-element-delete': currentUser.role === 'admin' }">

                            <a :class="item.sender_id === currentUser.id ? 'pull-right' : 'pull-left'">
                                <img :alt="item.sender.first_name" class="img-circle" :src="item.sender.profile_picture">
                            </a>
                            <div class="media-body" :class="{ 'text-right': item.sender_id === currentUser.id }">
                                <div>
                                    <small :class="item.sender_id === currentUser.id ? 'pull-left' : 'pull-right'">
                                        {{ formatDate(item.created_at) }}
                                    </small>
                                    <small :class="item.sender_id === currentUser.id ? 'pull-right' : 'pull-left'">
                                        {{ item.sender.first_name }}
                                    </small>
                                </div>
                                <br>
                                <p class="m-b-xs">
                                    {{ item.body }}
                                </p>
                                <small class="text-muted">
                                    Enviado: {{ moment(item.created_at).format('DD/MM/YYYY hh:mm') }}
                                    
                                    <!--span v-if="item.sender_id === currentUser.id && item.read_at != null">
                                        <i class="fa fa-eye"></i>
                                    </span-->
                                    <span v-if="currentUser.role === 'admin' && item.read_at != null">
                                        <br>Visualizado: {{ moment(item.read_at).format('DD/MM/YYYY hh:mm') }}
                                    </span>
                                    <!--span v-if="item.sender_id === currentUser.id && item.read_at == null">
                                        <i class="fa fa-eye-slash"></i>
                                    </span-->

                                </small>
                            </div>

                            <button v-if="currentUser.role === 'admin'" class="delete-message-button btn btn-md btn-danger" v-on:click="deleteMessage(item.id)">
                                Deletar mensagem <i class="fa fa-trash"></i>
                            </button>

                        </div>

                        <div v-else="item.type === 'meeting'" class="chat-element" style="background: #99ffb9;" :class="{ 'right': item.created_by === currentUser.id }">
                            
                            <a :class="item.created_by === currentUser.id ? 'pull-right' : 'pull-left'">
                                <img :alt="item.creator.first_name" class="img-circle" :src="item.creator.profile_picture">
                            </a>

                            <div class="media-body" :class="{ 'text-right': item.created_by === currentUser.id }">
                                <small :class="item.created_by === currentUser.id ? 'pull-left' : 'pull-right'">
                                    {{ formatDate(item.created_at) }}
                                </small>
                                
                                <br>
                                
                                <div v-if="item.ended_at">
                                    <p v-if="item.created_by !== currentUser.id" class="m-b-xs">
                                        <i class="fa fa-phone"></i> {{ item.creator.first_name }} iniciou uma chamada que durou {{ calculateDuration(item.started_at, item.ended_at) }}.
                                    </p>
                                    <p v-else class="m-b-xs">
                                        <i class="fa fa-phone"></i> Você iniciou uma chamada que durou {{ calculateDuration(item.started_at, item.ended_at) }}.
                                    </p>
                                </div>
                                
                                <div v-else>
                                    <p class="m-b-xs">
                                        <i class="fa fa-phone"></i> {{ item.creator.first_name }} está te aguardando em uma chamada nesse momento, clique em <strong>Reunião instantânea</strong> para acessá-la.
                                    </p>
                                </div>

                                <small class="text-muted">
                                    {{ moment(item.created_at).format('DD/MM/YYYY hh:mm') }}
                                </small>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <div v-if="currentUser.role != 'admin'" class="chat-form">
                <div class="form-group">
                    <textarea style="min-height: 80px; max-height: 150px;resize: vertical;"
                        class="form-control"
                        placeholder="Mensagem"
                        id="id_body"
                        name="body"
                        v-model="newMessage"
                        @keydown.enter="sendMessage"
                    ></textarea>
                </div>
                <div v-if="subscription.bid.user_id != null" class="text-right"> 
                    <button class="pull-left btn btn-sm btn-primary m-t-n-xs" onclick="openModal('agendamento-reunioes')">
                        <i class="fa fa-video-camera" aria-hidden="true"></i> 
                        Agendamento de reuniões
                    </button>
                    <button v-if="currentUser.role != 'admin'" class="pull-left btn btn-sm btn-meeting m-t-n-xs" id="startMeet" onclick="openModal('reuniao-instantanea')">
                        <i class="fa fa-video-camera" aria-hidden="true"></i> 
                        Reunião instantânea
                    </button> 
                    <button v-on:click="sendMessage" class="btn btn-sm btn-primary m-t-n-xs">
                        <strong>Enviar Mensagem</strong>
                    </button>
                </div>
                <div v-else>
                    <div style="text-align:center;">
                    <strong>Usuário desativou a conta na plataforma</strong>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import moment from 'moment';
    //import io from 'socket.io-client';

    export default {
        props: {
            recipient: {
                type: Object,
                required: true,
            },
            messages: {
                type: Array,
                required: true,
            },
            meetings: {
                type: Array,
                required: true,
            },
            subscription: {
                type: Object,
                required: true,
            },
            currentUser: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                newMessage: '',
                moment: moment,
                //socket: null,
                messagesData: [],
                meetingsData: [],
            };
        },
        mounted() {

            this.messagesData = this.messages;
            this.meetingsData = this.meetings;
            
            //const self = this;

            // self.socket = io(location.host + ':' + process.env.MIX_SOCKET_IO_PORT, {
            //     reconnectionAttempts: '5',
            //     reconnectionDelayMax: '10000',
            //     auth: {
            //         token: await this.getToken()
            //     }
            // });

            //     self.socket.on("connect", function (){
            //         self.socket.emit("user_connected", self.subscription.id + '_' +self.currentUser.id)
            //     });

            // self.socket.on("connect_error", async () => {

            //     self.socket.auth.token = await this.getToken();

            //});

            //self.socket.on("private-channel:"+self.subscription.id, function (data) {
                
            //     var existingIndex = self.sortedItems.findIndex(item => item.id === data.id);

            //     if (existingIndex !== -1)
            //         self.sortedItems[existingIndex] = data;
                
            //     else{

            //         self.sortedItems.push(data);
            //         self.sortedItems.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

            //     }
                
            //     self.$forceUpdate(); 
                
            //     self.$nextTick(function() {
            //         var container = document.querySelector('.chat-view');
            //         container.scrollTop = container.scrollHeight;
            //     });

            //});
 
        },
        computed: {
            sortedItems: {
                get() {
                    const items = [
                        ...this.messagesData.map(message => ({ ...message, type: 'message' })),
                        ...this.meetingsData.map(meeting => ({ ...meeting, type: 'meeting' })),
                    ];

                    return items.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                },
                set(value) {

                    this.messagesData = value.filter(item => item.type === 'message');
                    this.meetingsData = value.filter(item => item.type === 'meeting');
                    
                },
            },
        },
        methods: {
            // async getToken() {

            //     try {

            //         const response = await axios.get('/users/generate_jwt');

            //         return response.data.access_token;

            //     } catch (error) {

            //         console.error('Erro ao renovar o token JWT', error);

            //     }

            // },
            sendMessage() {

                if (this.newMessage.trim().length > 0) {
                    
                    axios.post('/chat/validate/'+this.subscription.id, { body: this.newMessage })
                        .then( (response) => {
                             
                            if(response.data.success){

                                axios.post('/chat/' + this.subscription.id, { body: this.newMessage })
                                    .then((response) => {
                                        
                                        this.sortedItems.push(response.data.message);
                                        this.sortedItems.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                                        this.$forceUpdate(); 
                                        
                                        this.$nextTick(function() {
                                            var container = document.querySelector('.chat-view');
                                            container.scrollTop = container.scrollHeight;
                                        });

                                    })
                                    .catch((error) => {

                                        console.error(error);
                                        toastr.error('Erro ao enviar a mensagem');

                                    });
                                
                                this.newMessage = '';
                                
                                return true;

                            }
                            
                            toastr.error(response.data.message);
                            
                            return false;

                        })
                        .catch((error) => {
 
                            console.error(error);
                            toastr.error('Erro ao validar mensagem');

                            return false;

                        });

                }else
                    toastr.error('Nenhuma mensagem informada para envio');

            },
            formatDate(date)  {

                const now = moment();
                const parsedDate = moment(date);
                const difference = now.diff(parsedDate, 'minutes');

                if (difference < 60) {

                    return `Há ${difference} minutos`;

                } else if (difference < 24 * 60) {

                    const horas = Math.floor(difference / 60);

                    return `Há ${horas} horas`;

                } else if (difference < 30 * 24 * 60) {

                    const dias = Math.floor(difference / (24 * 60));
                    return `Há ${dias} dias`;

                } else if (difference < 12 * 30 * 24 * 60) {

                    const meses = Math.floor(difference / (30 * 24 * 60));
                    return `Há ${meses} meses`;

                } else {

                    const anos = Math.floor(difference / (12 * 30 * 24 * 60));
                    return `Há ${anos} anos`;

                }

            },
            calculateDuration(startedAt, endedAt) {

                const startMoment = moment(startedAt);
                const endMoment = moment(endedAt);
                const duration = moment.duration(endMoment.diff(startMoment));
                const hours = duration.hours();
                const minutes = duration.minutes();
                const seconds = duration.seconds();

                let durationString = '';
                
                if (hours > 0)
                    durationString += `${hours} hora(s) `;

                else if(minutes > 0)
                    durationString += `${minutes} minuto(s) `;

                else if (minutes <= 0)
                    durationString += `${seconds} segundo(s) `;
                
                return durationString.trim();

            },
            deleteMessage(messageId){

                if (this.currentUser.role === 'admin') {

                    axios.delete('/chat/delete/' + messageId)
                        .then((response) => {
                            
                            if (response.data.success)
                                toastr.success(response.data.message);

                            else
                                toastr.error(response.data.message);


                        })
                        .catch(() => {

                            toastr.error('Houve um problema ao excluir a mensagem');
                                
                        });
                    
                }else
                    toastr.error('Sem permissao');
                
            }
        },
    };
</script>

<style>

    .btn-meeting {
        color:white;
        margin-left: 10px; 
        background-color: #60bd60; 
        border-color: #60bd60;
    }

    .btn-meeting:hover {
        background-color: #5ebf5e; 
        border-color: #5ebf5e;
    }

    .chat-element-delete:hover {

        background-color: #a0d9ff !important;

        .delete-message-button {
            display: block;
        }

    }

    .delete-message-button {
        display: none;
    }

</style>